import { Children, forwardRef, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { StyledTooltip } from './styled';
import { useTooltip } from '../../hooks/useTooltip';

const Tooltip = forwardRef((props, ref) => {
  const { children, text } = props;
  const { isOpen, tooltipProps, referenceProps } = useTooltip(ref, props);

  const tooltip = createPortal(
    isOpen && <StyledTooltip {...tooltipProps()}>{text}</StyledTooltip>,
    document.body
  );

  return (
    <>
      {cloneElement(Children.only(children), referenceProps())}
      {text && <>{tooltip}</>}
    </>
  );
});

export default Tooltip;
